// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__k-0PP","overflowing":"ReadFullNote_overflowing__2M14T"};